import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-download\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.50029 9.71985L10.8642 7.35595L11.5713 8.06306L8.35669 11.2777L8.00313 11.6312L7.64958 11.2777L4.43497 8.06306L5.14208 7.35595L7.50029 9.71416V1.6377H8.50029V9.71985ZM14.9324 8.0668V14.496V14.996H14.4324H1.57397H1.07397V14.496V8.06976H2.07397V13.996H13.9324V8.0668H14.9324Z\" fill=\"#323232\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol